<template>
  <img src="@/assets/icons/wood.png" width="44" height="44" />
</template>

<script setup lang="ts"></script>
